import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/documents/{documentId}/internal-data']['GET'];
type Input = ThisApi['params'];

const getExtractedData = async ({ documentId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(`/documents/${documentId}/internal-data`);
  return response.data;
};

export default getExtractedData;
